import React, { useContext, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { PageContext } from '../Context/PageProvider'
import { Button, Typography, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Grid, FormControl, InputLabel, Select, MenuItem, Switch, FormControlLabel, FormHelperText, Box } from '@material-ui/core'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'


const TITLE_MAX_LENGTH = 120
const BODY_MAX_LENGTH = 400

const INPUT_VALUES = {
    messageType: null,
    language: null,
    target: 'customer',
    pushNotification: false,
    title: null,
    body: null,
    link: null
}

function MessageModal({ t, item, open, handleClose }) {
    const context = useContext(PageContext)
    const api = context.api

    const classes = useStyles()

    const [counter, setCounter] = useState({ title: TITLE_MAX_LENGTH, body: BODY_MAX_LENGTH })
    const [values, setValues] = useState(item ? { ...item } : { ...INPUT_VALUES })
    const [errors, setErrors] = useState({ messageType: null, language: null, target: null })
    const [loading, setLoading] = useState(false)

    const handlePublish = async () => {
        try {
            const requiredFields = ['title', 'messageType', 'language', 'target']
            let error = false
            requiredFields.map(key => {
                if (!values[key]) {
                    setErrors(prevState => ({ ...prevState, [key]: true }))
                    error = true
                }
            })
            if (error) return

            setLoading(true)
            console.log('loading:', loading)

            item ? await api.messageService.updateMessage(values)
                : await api.messageService.addMessage(values)

            await context.loadMessages()
            handleClose()
            

        } catch (error) {
            setLoading(false)
            console.log('Message Modal handlePublish Error: ', error)
        }
    }

    const handleOnChange = (key, value) => {
        setValues(prevState => ({ ...prevState, [key]: value }))
        setErrors(prevState => ({ ...prevState, [key]: false }))
    }

    const HelperText = ({ leftText, rightText }) => {
        return (
            <Grid container style={{ padding: 0 }}>
                <Typography component="p" variant="caption" style={{ flex: 1 }}>
                    {leftText && leftText}
                </Typography>
                <Typography component="p" variant="caption" >
                    {rightText && rightText}
                </Typography>
            </Grid>
        )
    }

    return (
        <Dialog open={open} onClose={handleClose} fullWidth >
            {loading && <LinearProgress className={classes.linearProgress} />}
            <DialogTitle>{item ? item.title : t('new_message')}</DialogTitle>
            <DialogContent>
                <ValidatorForm onSubmit={handlePublish}>
                    <Grid container>
                        <Grid item xs={6}>
                            <FormControl className={classes.formControl} error={errors.messageType} disabled={loading}>
                                <InputLabel shrink> {t('message_type')} </InputLabel>
                                <Select value={values.messageType} onChange={(e) => handleOnChange('messageType', e.target.value)}>
                                    <MenuItem value={'alert'}>{t('alert')}</MenuItem>
                                    <MenuItem value={'message'}>{t('message')}</MenuItem>
                                </Select>
                                {errors.messageType && <FormHelperText>{t('this_field_is_required')}</FormHelperText>}
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl className={classes.formControl} error={errors.language} disabled={loading}>
                                <InputLabel shrink> {t('language')} </InputLabel>
                                <Select value={values.language} onChange={(e) => handleOnChange('language', e.target.value)}>
                                    <MenuItem value={'de'}>{t('german')}</MenuItem>
                                    <MenuItem value={'en'}>{t('english')}</MenuItem>
                                </Select>
                                {errors.language && <FormHelperText>{t('this_field_is_required')}</FormHelperText>}
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl className={classes.formControl} error={errors.target} disabled={true}>
                                <InputLabel shrink> {t('target')} </InputLabel>
                                <Select value={values.target} /*onChange={(e) => handleOnChange('target', e.target.value)}*/>
                                    <MenuItem value={"all"}>{t('all')}</MenuItem>
                                    <MenuItem value={'customer'}>{t('guest')}</MenuItem>
                                    <MenuItem value={'trainer'}>{t('trainer')}</MenuItem>
                                </Select>
                                {errors.target && <FormHelperText>{t('this_field_is_required')}</FormHelperText>}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    item ?
                                        <Switch
                                            checked={values.pushNotification}
                                            onChange={(event) => setValues(prevState => ({ ...prevState, pushNotification: event.target.checked }))}
                                            color="primary"
                                            disabled
                                        />
                                        :
                                        <Switch
                                            checked={values.pushNotification}
                                            onChange={(event) => setValues(prevState => ({ ...prevState, pushNotification: event.target.checked }))}
                                            color="primary"
                                            disabled={loading}
                                        />
                                }
                                label={t('push_notification')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextValidator className={classes.formControl}
                                label={t('title')}
                                onChange={(event) => {
                                    const _title = event.target.value
                                    if (_title.length <= TITLE_MAX_LENGTH) {
                                        setValues(prevState => ({ ...prevState, title: _title }))
                                        setCounter(prevState => ({ ...prevState, title: TITLE_MAX_LENGTH - _title.length }));
                                    }
                                }}
                                type="text"
                                validators={['required']}
                                errorMessages={[t('this_field_is_required')]}
                                helperText={<HelperText rightText={`${counter.title}/${TITLE_MAX_LENGTH}`} />}
                                disabled={loading}
                                value={values.title}

                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextValidator
                                label={t('body')}
                                className={classes.formControl}
                                onChange={(event) => {
                                    const _body = event.target.value
                                    if (_body.length <= BODY_MAX_LENGTH) {
                                        setValues(prevState => ({ ...prevState, body: _body }))
                                        setCounter(prevState => ({ ...prevState, body: BODY_MAX_LENGTH - _body.length }));
                                    }

                                }}
                                type="text"
                                value={values.body}
                                disabled={loading}
                                multiline
                                maxlength={BODY_MAX_LENGTH}
                                rows={4}
                                helperText={<HelperText leftText={t('optional')} rightText={`${counter.body}/${BODY_MAX_LENGTH}`} />}
                            />

                        </Grid>
                        <Grid item xs={12}>
                            <TextValidator
                                label={t('link')}
                                className={classes.formControl}
                                type="text"
                                disabled={loading}
                                helperText={t('optional')}
                                value={values.link}
                                onChange={(event) => { setValues(prevState => ({ ...prevState, link: event.target.value })) }}
                            />
                        </Grid>

                        <DialogActions className={classes.buttonContainer}>
                            <Box className={classes.cancelButton}>
                                <Button onClick={handleClose} color="primary" disabled={loading} >
                                    {t('cancel')}
                                </Button>
                            </Box>
                            <Box className={classes.publishButton}>
                                <Button type="submit" color="primary" variant="contained" onClick={handlePublish} disabled={loading}>
                                    {item ? t('update') : t('publish')}
                                </Button>
                            </Box>

                        </DialogActions>
                    </Grid>
                </ValidatorForm>
            </DialogContent>

        </Dialog>

    )
}

const useStyles = makeStyles((theme) => ({
    linearProgress: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 9999
    },
    formControl: {
        paddingRight: theme.padding.medium,
        marginBottom: theme.margin.medium,
        minWidth: 120,
    },
    buttonContainer: {
        flex: 1
    },
    cancelButton: {
        display: 'flex',
        flex: 1
    },
    publishButton: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end'
    }
}))

export default withTranslation()(withRouter(MessageModal))